import React, { Component } from "react";
import Breadcrumbs from 'core/components/SecondaryHeader'
import {Wrapper} from './components/Styled'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import LazyImage from 'core/components/LazyImage'
import Accordion from "../../../../core/components/Accordion";
import PuppySeekerNav from "../PuppySeekerNav";
import Slider from 'react-slick'

function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className="next_arrow"
        onClick={onClick}>
            &#8963;
      </div>
    );
}

function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className="prev_arrow"
        onClick={onClick}>
            &#8963;
      </div>
    );
}

class PuppyChoose extends Component {

  constructor(props) {
    super(props);
  }

  static defaultProps = {
    title: '',
    cms: {},
  }

  static propTypes = {
    cms: PropTypes.object.isRequired,
  }
  
  getLeftItems () {
    return [
      {
        text: 'Home',
        isLink: true,
        isActive: true,
        props: {
          href: '/'
        }
      },
      {
        text: 'Choosing a Breed',
        isLink: false,
        isActive: false,
        props: {
          href: '/'
        }
      }
    ]
  }

  removeHTMLtags( string ) {
    let regex = /(<([^>]+)>)/ig
    return (string) ? string.replace(regex, "") : ''
  }

  render() {

    const settings = {
        arrows: true,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };

    const settings2 = {
        arrows: true,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,        
        responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1.2,
                slidesToScroll: 1
              }
            }
          ]        
    };    

    return (
      <div>
      <div className='marketplace__top-image'>

        <Breadcrumbs items={this.getLeftItems()} />

      </div>

      <Wrapper className={`static-page`}>
        <div className='static-page__section'>
          <div className='header' >
              <h1> { this.removeHTMLtags( this.props.cms['choosing-a-breed-heading'] ) } </h1>
          </div>
          <PuppySeekerNav />
            <div className='section-1' >
                <div className='img-wrap' >
                    <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-1-image'] ) }  className='section-1-img' />
                </div>
                <div className='text-wrap' >
                    <h2> { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-1-heading'] ) } </h2>
                    
                    <p dangerouslySetInnerHTML={{ __html:  this.props.cms['choosing-a-breed-section-1-text']  }} /> 

                    <a className="button-orange" target="_blank" href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-1-button-link'] ) }  >
                        { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-1-button-text'] ) }
                    </a>
                </div>
            </div>
          <div>

          <div className='section-2' >
            <h2> { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-heading'] ) } </h2>
            <div className="img-wrap" >
                <div className="wrap" >
                    <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-image-1'] ) }  className='section-2-img' />

                    <p className="wrap-title"> { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-slide-1-title'] ) } </p>
                    <p className="wrap-text" > { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-slide-1-text'] ) } </p>

                    <a className="button" target="_blank" href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-button-1-link'] ) }  >
                        { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-button-1-text'] ) }
                    </a>
                </div>
                <div className="wrap" >
                    <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-image-2'] ) }  className='section-2-img' />

                    <p className="wrap-title"> { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-slide-2-title'] ) } </p>
                    <p className="wrap-text" > { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-slide-2-text'] ) } </p>

                    <a className="button" target="_blank" href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-button-2-link'] ) }  >
                        { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-button-2-text'] ) }
                    </a>
                </div>
            </div>

            <div className="slider-wrap" >
                <Slider {...settings}  >
                    <div>
                        <div className="wrap" >
                            <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-image-1'] ) }  className='section-2-img' />

                            <p className="wrap-title"> { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-slide-1-title'] ) } </p>
                            <p className="wrap-text"> { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-slide-1-text'] ) }</p>

                            <a className="button" target="_blank" href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-button-1-link'] ) }  >
                                { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-button-1-text'] ) }
                            </a>
                        </div>
                    </div>
                    <div>
                    <div className="wrap" >
                        <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-image-2'] ) }  className='section-2-img' />

                        <p className="wrap-title" > { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-slide-2-title'] ) }</p>
                        <p className="wrap-text" > { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-slide-2-text'] ) }</p>

                            <a className="button" target="_blank" href={ this.removeHTMLtags(this.props.cms['choosing-a-breed-section-2-button-2-link'] ) }  >
                                { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-2-button-2-text'] ) }
                            </a>
                        </div>
                    </div>
                </Slider>
            </div>

          </div>

            <div className='section-3' >
                <h2> { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-3-heading'] ) }</h2>

                <div className="accordion-wrap" >

                    <Accordion content={ this.props.cms['choosing-a-breed-accordion-1-content'] } title={ this.removeHTMLtags( this.props.cms['choosing-a-breed-accordion-1-title']) }  />

                    <Accordion content={ this.props.cms['choosing-a-breed-accordion-2-content'] } title={ this.removeHTMLtags( this.props.cms['choosing-a-breed-accordion-2-title']) }  />

                    <Accordion content={ this.props.cms['choosing-a-breed-accordion-3-content'] } title={ this.removeHTMLtags( this.props.cms['choosing-a-breed-accordion-3-title']) }  />
                    
                </div>
            </div>

            <div className='section-4' >
                <h2> { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-heading'] ) }</h2>

                <div className='img-row' >
                    <div>
                        <div className="img-row-box" >
                            <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-1-image'] ) }  className='section-2-img' />
                            <a className="img-row-box-text" href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-1-link'] ) } target="_blank">
                                { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-1-text'] ) }
                            </a>                            
                        </div>
                    </div>
                    <div>
                        <div className="img-row-box" >
                            <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-2-image'] ) }  className='section-2-img' />
                            <a className="img-row-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-4-slider-2-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-2-link'] ) } target="_blank">
                            </a>
                        </div>
                    </div>
                    <div>
                        <div className="img-row-box" >
                            <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-3-image'] ) }  className='section-2-img' />
                            <a className="img-row-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-4-slider-3-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-3-link'] ) } target="_blank" >
                            </a>
                        </div>
                    </div>
                    <div>
                        <div className="img-row-box" >
                            <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-4-image'] ) }  className='section-2-img' />
                            <a className="img-row-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-4-slider-4-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-4-link'] ) } target="_blank" >
                            </a>
                        </div>
                    </div>
                </div>

                <div className='mobile-slider' >
                    <Slider {...settings2}>
                        <div>
                            <div className="mobile-box" >
                                <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-1-image'] ) } className='' />
                                <a className="mobile-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-4-slider-1-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-1-link'] ) } target="_blank" >
                                </a>
                            </div>
                        </div>
                        <div>
                            <div className="mobile-box" >
                                <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-2-image'] ) } className='' />
                                <a className="mobile-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-4-slider-2-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-2-link'] ) } target="_blank" >
                                </a>
                            </div>
                        </div>
                        <div>
                            <div className="mobile-box" >
                                <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-3-image'] ) } className='' />
                                <a className="mobile-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-4-slider-3-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-3-link'] ) } target="_blank" >
                                </a>
                            </div>
                        </div>
                        <div>
                            <div className="mobile-box" >
                                <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-4-image'] ) } className='' />
                                <a className="mobile-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-4-slider-4-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-4-slider-4-link'] )} target="_blank" >
                                </a>
                            </div>
                        </div>                        
                    </Slider>
                </div>
            </div>

            <div className='section-5' >
                <h2> { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-heading'] ) }</h2>

                <div className='img-row' >
                    <div>
                        <div className="img-row-box" >
                            <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-slider-1-image'] ) }  className='section-2-img' />
                            <a className="img-row-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-5-slider-1-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-slider-1-link'] ) } target="_blank" >
                            </a>
                        </div>
                    </div>
                    <div>
                        <div className="img-row-box" >
                            <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-slider-2-image'] ) }  className='section-2-img' />
                            <a className="img-row-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-5-slider-2-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-slider-2-link'] ) } target="_blank" >
                            </a>
                        </div>
                    </div>
                    <div>
                        <div className="img-row-box" >
                            <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-slider-3-image'] ) }  className='section-2-img' />
                            <a className="img-row-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-5-slider-3-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-slider-3-link'] ) } target="_blank" >
                            </a>
                        </div>
                    </div>
                    <div>
                        <div className="img-row-box" >
                            <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-slider-4-image'] ) }  className='section-2-img' />
                            <a className="img-row-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-5-slider-4-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-slider-4-link'] ) } target="_blank" >
                            </a>
                        </div>
                    </div>
                </div>

                <div className='mobile-slider' >
                    <Slider {...settings2}>
                        <div>
                            <div className="mobile-box" >
                                <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-slider-1-image'] ) } className='' />
                                <a className="mobile-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-5-slider-1-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-slider-1-link'] ) } target="_blank" >
                                </a>
                            </div>
                        </div>
                        <div>
                            <div className="mobile-box" >
                                <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-slider-2-image'] ) } className='' />
                                <a className="mobile-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-5-slider-2-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-slider-2-link'] ) } target="_blank" >
                                </a>
                            </div>
                        </div>
                        <div>
                            <div className="mobile-box" >
                                <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-slider-3-image'] ) } className='' />
                                <a className="mobile-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-5-slider-3-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-slider-3-link'] ) } target="_blank" >
                                </a>
                            </div>
                        </div>
                        <div>
                            <div className="mobile-box" >
                                <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-slider-4-image'] ) } className='' />
                                <a className="mobile-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-5-slider-4-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-5-slider-4-link'] ) } target="_blank" >
                                </a>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>

            <div className='section-6' >

                <h2> { this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-heading'] ) }</h2>

                <div className='img-row' >
                    <div>
                        <div className="img-row-box" >
                            <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-slider-1-image'] ) }  className='section-2-img' />
                            <a className="img-row-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-6-slider-1-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-slider-1-link'] ) } target="_blank" >
                            </a>
                        </div>
                    </div>
                    <div>
                        <div className="img-row-box" >
                            <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-slider-2-image'] ) }  className='section-2-img' />
                            <a className="img-row-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-6-slider-2-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-slider-2-link'] ) } target="_blank" >
                            </a>
                        </div>
                    </div>
                    <div>
                        <div className="img-row-box" >
                            <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-slider-3-image'] ) }  className='section-2-img' />
                            <a className="img-row-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-6-slider-3-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-slider-3-link'] ) } target="_blank" >
                            </a>
                        </div>
                    </div>
                    <div>
                        <div className="img-row-box" >
                            <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-slider-4-image'] ) }  className='section-2-img' />
                            <a className="img-row-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-6-slider-4-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-slider-4-link'] ) } target="_blank" >
                            </a>
                        </div>
                    </div>
                </div>

                <div className='mobile-slider' >
                    <Slider {...settings2}>
                        <div>
                            <div className="mobile-box" >
                                <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-slider-1-image'] ) } className='' />
                                <a className="mobile-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-6-slider-1-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-slider-1-link'] ) } target="_blank" >
                                </a>
                            </div>
                        </div>
                        <div>
                            <div className="mobile-box" >
                                <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-slider-2-image'] ) } className='' />
                                <a className="mobile-box-text"  dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-6-slider-2-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-slider-2-link'] ) } target="_blank" >
                                </a>
                            </div>
                        </div>
                        <div>
                            <div className="mobile-box" >
                                <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-slider-3-image'] ) } className='' />
                                <a className="mobile-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-6-slider-3-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-slider-3-link'] ) } target="_blank" >
                                </a>
                            </div>
                        </div>
                        <div>
                            <div className="mobile-box" >
                                <LazyImage src={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-slider-4-image'] ) } className='' />
                                <a className="mobile-box-text" dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-6-slider-4-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-6-slider-4-link'] ) } target="_blank" >
                                </a>
                            </div>
                        </div>                        
                    </Slider>
                </div>                

            </div>

            <div className='section-7' >
                <h2 dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-7-heading']}} />
                <a className="button" target="_blank"  dangerouslySetInnerHTML={{ __html: this.props.cms['choosing-a-breed-section-7-button-text']}} href={ this.removeHTMLtags( this.props.cms['choosing-a-breed-section-7-button-link'] ) } >
                </a>
            </div>            

          </div>
        </div>
      </Wrapper>
    </div>
    )
  }

  }

  const mapStateToProps = state => ({
    cms: state.app.cms,
  })

  export default connect(
    mapStateToProps,
    null
  )(PuppyChoose)